import useTranslation from 'next-translate/useTranslation';

const HasAdded = () => {
  const { t } = useTranslation();

  return (
    <div className="w-fit py-4 text-left">
      <p>{t('common:added_to_cart')}</p>
    </div>
  );
};

export default HasAdded;
